module.exports = __webpack_public_path__ + "img/payment-timer-icon.svg";